import { cloneDeep } from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';

import cart from './cart';
import menu from './menu';
import order from './order';
import user from './user';

Vue.use(Vuex);

const initialState = {
  cart: cart.state(),
  menu: menu.state(),
  order: order.state(),
  user: user.state(),
};

export default new Vuex.Store({
  modules: {
    cart,
    menu,
    order,
    user,
  },
  actions: {
    reset({ commit }) {
      commit('reset');
    },
  },
  mutations: {
    reset(state) {
      const copyState = cloneDeep(initialState);
      Object.keys(state).forEach((key) => {
        Object.assign(state[key], copyState[key]);
      });
    },
  },
});
